
import { Component, Vue } from "vue-property-decorator";
import VerticalVideoep from "@/template/video/VerticalVideo.vue";
@Component
export default class VerticalVideo extends VerticalVideoep {
  get commentImg() {
    return require("@/assets/形状 29.png");
  }
  get praiseImg() {
    if (this.isPraise) {
      return require("@/assets/已点赞@2x.png");
    } else {
      return require("@/assets/形状 27 拷贝 2.png");
    }
  }

  get shareImg() {
    return require("@/assets/分享@2x.png");
  }

  get sliderColor() {
    return "#d50017";
  }
}
